

// Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { logo } from './index';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 w-full z-50">
      {/* Top Contact Bar */}
      <div className="w-full bg-black/30 text-white py-2 px-4 flex flex-col md:flex-row justify-between items-center">
        {/* <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
          <div className="flex items-center space-x-2">
            <Phone size={16} />
            <a href="tel:+919112474911" className="hover:underline text-sm">
              +91 9112474911
            </a>
          </div>
          <div className="flex items-center space-x-2">
            <Mail size={16} />
            <a href="mailto:info@nirmitainternational.com" className="hover:underline text-sm">
              info@nirmitainternational.com
            </a>
          </div>
        </div> */}


        {/* <div className="flex items-center space-x-4 mt-2 md:mt-0">
          <div className="flex justify-start space-x-4 mt-4">
            <a
              href="https://www.facebook.com/profile.php?id=61579068592688"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook size={20} className="text-gray-300 hover:text-white" />
            </a>
            <a
              href="https://www.instagram.com/nirmita_international/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={20} className="text-gray-300 hover:text-white" />
            </a>
              <a
              href="https://www.linkedin.com/company/nirmita-international/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Linkedin"
            >
              <Linkedin size={20} className="text-gray-300 hover:text-white" />
            </a>
          </div>

        </div> */}
        <div className="w-full bg-transparent py-4 px-6 flex justify-between items-center h-20">
          <div className="flex items-center space-x-3 h-full">
            <img
              src={logo}
              alt="Logo"
              className="max-h-16 md:max-h-20 w-auto object-contain"
            />
          </div>

          <div className="hidden md:flex items-center space-x-6">
            <nav className="flex space-x-8 items-center">
              <Link to="/" className="text-white hover:text-amber-200 text-lg">Home</Link>
              <Link to="/aboutus" className="text-white hover:text-amber-200 text-lg">About Us</Link>
              <Link to="/categories" className="text-white hover:text-amber-200 text-lg">Categories</Link>
              <Link to="/certificates" className="text-white hover:text-amber-200 text-lg">Certificate</Link>
              <Link to="/contact-us" className="text-white hover:text-amber-200 text-lg">Contact Us</Link>
            </nav>
          </div>

          <div className="md:hidden flex items-center space-x-3">
            <button className="text-white" onClick={() => setMenuOpen(true)}>
              <Menu size={32} />
            </button>
          </div>
        </div>
      </div>

      {/* Main Navigation */}



      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-50 flex justify-end items-start md:hidden transition-opacity duration-300 ${menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
          }`}
      >
        {/* Dimmed background only behind menu (not full screen) */}
        <div
          className={`absolute inset-0 bg-black/40 transition-opacity duration-300 ${menuOpen ? "opacity-100" : "opacity-0"
            }`}
          onClick={() => setMenuOpen(false)}
        ></div>

        {/* Side Drawer */}
        <div
          className={`relative mt-4 mr-4 rounded-xl shadow-2xl overflow-hidden bg-white transform transition-transform duration-300 ${menuOpen ? "translate-x-0" : "translate-x-full"
            }`}
          style={{
            width: "80vw", // responsive width
            maxWidth: "280px", // limit size
            maxHeight: "80vh", // only as tall as content
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-4 border-b">
            <div className="flex items-center space-x-2">
              <img src={logo} alt="Logo" className="w-10 h-10 object-contain" />
            </div>
            <button
              className="text-gray-600 hover:text-gray-800"
              onClick={() => setMenuOpen(false)}
            >
              <X size={22} />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-col p-4 space-y-3">
            <Link to="/" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/aboutus" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>About Us</Link>
            <Link to="/categories/organic-products" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Organic Products</Link>
            <Link to="/categories/herbal-products" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Herbal Products</Link>
            <Link to="/categories/bagasse-tableware" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Bagasse Tableware</Link>
            <Link to="/categories/cocopit-coir" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Cocopit Coir Products</Link>
            <Link to="/certificates" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Certificate</Link>
            <Link to="/contact-us" className="text-gray-700 hover:text-amber-600" onClick={() => setMenuOpen(false)}>Contact Us</Link>
          </nav>

        </div>
      </div>

    </header>
  );
};

export default Header;